import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Orange_White_Border_Btn.css";

const Orange_White_Border_Btn = (props) => {
  return (
    <button
      className="Orange_White_Border_Btn"
      onClick={props?.onClick}
      type="button"
    >
      {props?.icon && (
        <div className="icon_holder">
          <FontAwesomeIcon icon={props?.icon} className="icon" />
        </div>
      )}
      <p className="btn_text">{props?.btn_name}</p>
    </button>
  );
};

export default Orange_White_Border_Btn;
